import React from 'react';
import { Modal } from 'rsuite';
import LoaderComponent from '../LoaderComponent';

const ModalComponent = ({ backdrop, open, handleClose, modalTitle, children, size = 'md', isLoading = false, dialogClassName = '', footer = null, bodyClass = '' }) => {
  return (
    <>
      <Modal size={size} backdrop={backdrop} keyboard={false} show={open} onHide={handleClose} dialogClassName={dialogClassName}>
        <Modal.Header>
          <Modal.Title className='fw-bold text-black fs-2 mb-0'>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={`d-flex flex-column align-items-center w-100 editscript-ui${isLoading ? ' position-relative loading' : ''} ${bodyClass}`}>
          {isLoading && <LoaderComponent />}
          {children}
        </Modal.Body>
        {footer ? (
          <Modal.Footer>
            {footer}
          </Modal.Footer>
        ) : (
          <></>
        )}
      </Modal>
    </>
  );
};

export default ModalComponent;